import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import style from "./content_sharing.module.css";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

const ContentSharingPost = () => {
    const { userid, contentid } = useParams();
    const { auth } = useContext(AuthContext);

    // content var
    const [contentList, setContentList] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selfUserId, setSelfUserId] = useState(null);
    const [status, setStatus] = useState(null);

    // comment var
    const [commentList, setCommentList] = useState([]);
    const [newComment, setNewComment] = useState("");
    const [replyingTo, setReplyingTo] = useState(null);
    const [replyText, setReplyText] = useState("");
    const [commentUserInfo, setCommentUserInfo] = useState({}); // userid -> { username, avatar }

    useEffect(() => {
        const decryptUserId = async () => {
            try {
                const response = await axios.post(
                    "https://umiuni.com:5002/api/user/decode_userid",
                    { encodedString: auth.userid },
                    { headers: { "Content-Type": "application/json" }, maxBodyLength: Infinity }
                );
                setSelfUserId(response.data.result);
            } catch (error) {
                console.error("Error decrypting user ID:", error);
            }
        };

        if (auth?.userid) {
            decryptUserId();
        }
    }, [auth]);

    const updateStatus = async (action, targetUserId) => {
        try {
            const data = {
                from_user_id: selfUserId,
                to_user_id: targetUserId,
            };

            const url = `https://ai-api.umiuni.com:8183/friends/${action}`;
            const result = await axios.post(url, data, {
                headers: { "Content-Type": "application/json" },
            });

            if (action === "check") {
                console.log(result.data);
                return result.data;
            }
        } catch (error) {
            console.error(error);
        }
    };

    // Fetch username + avatar for any commenter userid we don't already have cached
    const enrichCommentUsers = async (comments) => {
        const uniqueIds = [...new Set(comments.map(c => c.userid))]
            .filter(id => id != null && !commentUserInfo[id]);

        if (uniqueIds.length === 0) return;

        const results = await Promise.all(
            uniqueIds.map(async (id) => {
                try {
                    const encodeResp = await axios.post(
                        "https://umiuni.com:5002/api/user/encode_userid",
                        { userid: id },
                        { headers: { "Content-Type": "application/json" }, maxBodyLength: Infinity }
                    );
                    const encodedId = encodeResp.data.result;

                    const userResp = await axios.get(`${process.env.REACT_APP_API_URL}api/user/get`, {
                        params: { userid: encodedId },
                    });

                    const pfp = userResp.data.avatar || "94NCQ5GiFeXAVwr3alGqY7Zp9xlzpIGu";
                    return {
                        id,
                        username: userResp.data.username,
                        avatar: `https://oss.umiuni.com/${pfp}`,
                    };
                } catch (error) {
                    console.error(`Error fetching user info for userid ${id}:`, error);
                    return null;
                }
            })
        );

        const newEntries = results.filter(Boolean).reduce((acc, r) => {
            acc[r.id] = { username: r.username, avatar: r.avatar };
            return acc;
        }, {});

        setCommentUserInfo(prev => ({ ...prev, ...newEntries }));
    };

    const fetchComment = async () => {
        try {
            const { data } = await axios.get(`https://python.umiuni.com:5555/umiuni_comment_fetch/?pwd=testing&postid=${contentid}`);
            setCommentList(data);
            await enrichCommentUsers(data || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const { data } = await axios.get(`https://python.umiuni.com:5555/umiuni_content_getting_self/${userid}/?pwd=testing`);
                setContentList(data);
                const targetIndex = data.findIndex(item => item.id == contentid);
                setCurrentIndex(targetIndex);
                const statusResponse = await updateStatus("check", selectedUserId);
                setStatus(statusResponse?.status);

                await fetchComment();
            } catch (error) {
                console.error(error);
            }
        };

        fetchContent();
    }, [userid]);

    useEffect(() => {
        console.log(commentList);
    }, [commentList]);

    // --- comment actions ---

    const postComment = async (commentText, commSubId = "") => {
        if (!commentText.trim() || !selfUserId) {
            console.warn("Cannot post: missing comment text or selfUserId", { commentText, selfUserId });
            return;
        }
        try {
            const formData = new FormData();
            formData.append("pwd", "testing");
            formData.append("contentid", contentid);
            formData.append("userid", selfUserId);

            const subIdParam = commSubId ? `&comm_subid=${commSubId}` : "";
            const url = `https://python.umiuni.com:5555/umiuni_comment/?pwd=testing&userid=${selfUserId}&postid=${contentid}${subIdParam}&comment=${encodeURIComponent(commentText)}`;

            await axios.post(url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            await fetchComment();
        } catch (error) {
            console.error(error);
        }
    };

    const deleteComment = async (commentId, commSubId = null) => {
        if (!selfUserId) {
            console.warn("Cannot delete: missing selfUserId");
            return;
        }
        if (!window.confirm("Delete this comment?")) return;
        try {
            const formData = new FormData();
            formData.append("pwd", "testing");
            formData.append("contentid", contentid);
            formData.append("userid", selfUserId);

            const subIdParam = commSubId ? `&comm_subid=${commSubId}` : "";
            const url = `https://python.umiuni.com:5555/umiuni_comment_delete/?pwd=testing&userid=${selfUserId}&id=${commentId}&postid=${contentid}${subIdParam}`;

            await axios.post(url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            await fetchComment();
        } catch (error) {
            console.error(error);
        }
    };

    // --- content card (unchanged from original) ---

    const createCards = () => {
        if (contentList.length === 0 || currentIndex === null) return null;

        const item = contentList[currentIndex];

        const additionalFields = {
            id: item.id || null,
            userid: item.userid || null,
            created_time: item.created_time || null,
            photo_location: item.photo_location || null,
            content_name: item.content_name || null,
            page_num: item.page_num || null,
            text: item.text || null,
            book_link: item.book_link || null,
        };

        const handleStatus = async () => {
            const action = status === "following" ? "remove" : "follow";
            await updateStatus(action, additionalFields.userid);
            setStatus(status === "following" ? "none" : "following");
        };

        return (
            <div className={style.contentWrapper} key={currentIndex} style={{ paddingTop: "1rem" }}>
                <div className={style.content}>
                    {item.photo_location?.endsWith(".pdf") ? (
                        <a href={item.photo_location}>{item.content_name}</a>
                    ) : (
                        <img src={item.photo_location} alt={item.content_name} />
                    )}
                </div>
                <div className={style.additionalInfo}>
                    {additionalFields.userid && (
                        <>
                            <p className={style.userIdCont}>User ID: {additionalFields.userid}</p>
                            <button className={style.updateStatus} onClick={handleStatus}>
                                {status === "following" ? "Unfollow" : "Follow"}
                            </button>

                            <button
                                onClick={() => {
                                    const shareUrl = `https://umiuni.com/content_sharing/${additionalFields.userid}/${additionalFields.id}`;
                                    if (navigator.share) {
                                        navigator
                                            .share({
                                                title: "Check out this content!",
                                                text: `Take a look at this content shared by ${additionalFields.userid}.`,
                                                url: shareUrl,
                                            })
                                            .then(() => console.log("Successfully shared"))
                                            .catch((error) => console.error("Error sharing:", error));
                                    } else {
                                        navigator.clipboard.writeText(shareUrl).then(() => {
                                            alert("Link copied to clipboard");
                                        });
                                    }
                                }}
                                className={style.updateStatus}
                            >
                                Share
                            </button>
                        </>
                    )}
                    {additionalFields.created_time && <p>Created Time: {additionalFields.created_time}</p>}
                    {additionalFields.page_num && <p>Page Number: {additionalFields.page_num}</p>}
                    {additionalFields.content_name && <p>Book Name: {additionalFields.content_name}</p>}
                    {additionalFields.text && <p>Text: {additionalFields.text}</p>}
                    {additionalFields.book_link && (
                        <div className={style.addBook}>
                            <p>Book Link:</p>
                            <a href={additionalFields.book_link}>View Book</a>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    // --- comments section ---

    const topLevelComments = commentList.filter(c => !c.comm_subid || c.comm_subid == "0");
    const getReplies = (rootId) => commentList.filter(c => c.comm_subid == rootId);

    const renderComment = (comment, depth = 0) => {
        const isOwner = selfUserId && String(comment.userid) === String(selfUserId);
        const isReplying = replyingTo === comment.id;
        const replies = getReplies(comment.id);

        const parentComment = comment.comm_subid && comment.comm_subid != "0"
            ? commentList.find(c => String(c.id) === String(comment.comm_subid))
            : null;

        const threadRootId = comment.comm_subid && comment.comm_subid != "0"
            ? comment.comm_subid
            : comment.id;

        const commenterInfo = commentUserInfo[comment.userid];
        const commenterName = commenterInfo?.username || `User ${comment.userid}`;
        const parentInfo = parentComment ? commentUserInfo[parentComment.userid] : null;
        const parentName = parentComment ? (parentInfo?.username || `User ${parentComment.userid}`) : null;

        return (
            <div key={comment.id} className={style.commentItem} style={{ marginLeft: depth * 30 }}>
                <div className={style.commentHeader}>
                    <div className={style.commentUserInfo}>
                        {commenterInfo?.avatar && (
                            <img src={commenterInfo.avatar} alt={commenterName} className={style.commentAvatar} />
                        )}
                        <span className={style.commentUser}>{commenterName}</span>
                    </div>
                    {comment.created_time && <span className={style.commentTime}>{comment.created_time}</span>}
                </div>

                {parentComment && (
                    <p className={style.replyingToTag}>Replying to {parentName}</p>
                )}

                <p className={style.commentText}>{comment.comment}</p>

                <div className={style.commentActions}>
                    <button
                        className={style.replyButton}
                        onClick={() => {
                            setReplyingTo(isReplying ? null : comment.id);
                            setReplyText("");
                        }}
                    >
                        {isReplying ? "Cancel" : "Reply"}
                    </button>

                    {isOwner && (
                        <button
                            className={style.deleteButton}
                            onClick={() => deleteComment(comment.id, comment.comm_subid && comment.comm_subid != "0" ? comment.comm_subid : null)}
                        >
                            Delete
                        </button>
                    )}
                </div>

                {isReplying && (
                    <div className={style.replyBox}>
                        <input
                            type="text"
                            value={replyText}
                            onChange={(e) => setReplyText(e.target.value)}
                            placeholder="Write a reply..."
                            className={style.commentInput}
                        />
                        <button
                            className={style.submitButton}
                            onClick={async () => {
                                await postComment(replyText, threadRootId);
                                setReplyText("");
                                setReplyingTo(null);
                            }}
                        >
                            Post
                        </button>
                    </div>
                )}

                {replies.length > 0 && (
                    <div className={style.repliesWrapper}>
                        {replies.map(reply => renderComment(reply, depth + 1))}
                    </div>
                )}
            </div>
        );
    };

    const createComments = () => {
        return (
            <div className={style.commentsSection}>
                <h3 className={style.commentsTitle}>Comments ({commentList.length})</h3>

                {selfUserId != null && (
                    <div className={style.newCommentBox}>
                        <input
                            type="text"
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                            placeholder="Add a comment..."
                            className={style.commentInput}
                        />
                        <button
                            className={style.submitButton}
                            onClick={async () => {
                                await postComment(newComment, "");
                                setNewComment("");
                            }}
                        >
                            Post
                        </button>
                    </div>
                )}

                <div className={style.commentsList}>
                    {topLevelComments.length === 0 ? (
                        <p className={style.noComments}>No comments yet.</p>
                    ) : (
                        topLevelComments.map(comment => renderComment(comment))
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className={style.contentCards}>
            {createCards()}
            {createComments()}
        </div>
    );
};

export default ContentSharingPost;
